<template>
  <div class="page-col" >
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); px-3">
            <i class="fa fa-list-alt text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Estoque Diversos</h4>
            <small class="text-muted mb-0 d-none d-lg-block">Consulta e Trilha de Auditoria</small>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3 w-100 w-md-auto justify-content-end">
            <!-- Search Pill -->
            <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2 d-none d-lg-inline-flex">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                     <b-button variant="link" class="btn-icon-only text-success" @click="onRecalcular()" v-b-tooltip.hover title="Atualizar Estoque">
                        <i class="fa fa-refresh"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="imprimir()" v-b-tooltip.hover title="Imprimir">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <!-- Mobile Buttons Group -->
                 <b-button-group class="mr-2 d-lg-none">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2 date-inputs-responsive">
                    <b-form-select 
                        v-model="centroEstoqueIdLocal" 
                        class="bg-transparent border-0" 
                        :style="{ width: '200px', fontSize: '0.9rem' }" 
                        :options="centroEstoqueOptions">
                      <template slot="first">
                        <option :value="null">Centro de Estoque</option>
                      </template>
                    </b-form-select>
                </div>
                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <b-form-checkbox 
                        v-model="exibirZeradosLocal" 
                        switch
                        class="text-nowrap"
                        :style="{ fontSize: '0.85rem' }"
                    >
                        Exibir Zerados
                    </b-form-checkbox>
                </div>
                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <b-form-radio-group
                        v-model="visaoAtual"
                        buttons
                        button-variant="outline-primary"
                        size="sm"
                        class="text-nowrap font-weight-bold"
                    >
                        <b-form-radio value="produto">Produto</b-form-radio>
                        <b-form-radio value="grupo">Grupo</b-form-radio>
                        <b-form-radio value="vencimento">Vencimento</b-form-radio>
                    </b-form-radio-group>
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white btn-filtrar-responsive" :disabled="isBusy" @click="filtrar()">
                    <i class="fa fa-search mr-1"></i> <span class="d-none d-sm-inline">FILTRAR</span>
                </b-button>
            </div>
        </div>
      </div>

       <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtroAvancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium compact-filter p-3 border-0 shadow-sm">
                  <b-row>
                    <b-col md="6">
                         <b-form-group>
                            <produto-pesquisa
                                              @retornaId="produtoIdLocal = $event"
                                              :idInicial="produtoIdLocal"
                                              label="Produto"
                                              place="Opcional - Informe o Produto"
                                              labelBotao=""
                                              ref="produtopesquisa">
                            </produto-pesquisa>
                          </b-form-group>
                    </b-col>
                    <b-col md="6">
                         <b-form-group>
                            <grupo-produto-pesquisa
                                              @retornaId="grupoProdutoIdLocal = $event"
                                              :idInicial="grupoProdutoIdLocal"
                                              label="Grupo de Produtos"
                                              place="Opcional - Informe o Grupo"
                                              labelBotao=""
                                              ref="grupoProdutoPesquisa">
                            </grupo-produto-pesquisa>
                        </b-form-group>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0">
        <b-col sm="12" class="p-0">
          <!-- Container com padding lateral -->
          <div class="table-card-container px-3 px-md-4">
            <b-table 
                    class="modern-premium-table table-card-rows"
                    id="table-transition-example"
                    ref="tbl"
                    :busy.sync="isBusy" 
                    :items="itensTabelaExibidos" 
                    :fields="camposTabelaExibidos"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :sticky-header="stickyHeight"
                    :tbody-tr-class="rowClassSelecionado"
                    :row-key="rowKey"
                    :dark="isDark"
                    hover 
                    small 
                    show-empty
                    empty-text="Informe o filtro para ver os registros "
                    responsive
                    @row-clicked="selecionarLinha" 
                    >

                 <template #head(PRODUTO_ID)>
                  <SetFilter
                    label="Id"
                    v-model="filtros.PRODUTO_ID"
                    :options="opcoes.PRODUTO_ID"
                    :normalizeFn="normalize"
                    :dropdown-variant="isDark ? 'dark' : 'none'"
                  />
                </template>

                <template #head(DESCRICAO)>
                  <SetFilter
                    label="Produto"
                    v-model="filtros.DESCRICAO"
                    :options="opcoes.DESCRICAO"
                    :normalizeFn="normalize"
                    :dropdown-variant="isDark ? 'dark' : 'none'"
                  />
                </template>

                <template #head(DESCRICAO_CENTRO_ESTOQUE)>
                  <SetFilter
                    label="Centro Estoque"
                    v-model="filtros.DESCRICAO_CENTRO_ESTOQUE"
                    :options="opcoes.DESCRICAO_CENTRO_ESTOQUE"
                    :normalizeFn="normalize"
                    :dropdown-variant="isDark ? 'dark' : 'none'"
                  />
                </template>

                <!-- Formatação de valores monetários -->
                <template #cell(VL_CUSTO)="data">
                  {{ formatarMoeda(data.value) }}
                </template>

                <template #cell(VL_VENDA)="data">
                  {{ formatarMoeda(data.value) }}
                </template>

                <template #cell(TOTAL_CUSTO)="data">
                  {{ formatarMoeda(data.value) }}
                </template>

                <template #cell(TOTAL_VENDA)="data">
                  {{ formatarMoeda(data.value) }}
                </template>

                <!-- Formatação de datas -->
                <template #cell(VALIDADE)="data">
                  {{ formatarData(data.value) }}
                </template>

                <template #cell(ULTIMA_VENDA)="data">
                  {{ formatarData(data.value) }}
                </template>

                <!-- Destaque de dias sem venda -->
                <template #cell(DIAS_SEM_VENDA)="data">
                  <b-badge :variant="corDiasSemVenda(data.value)" pill>
                    {{ data.value || '-' }}
                  </b-badge>
                </template>

                <!-- Peças disponível vs reservado -->
                <template #cell(PECAS_DISPONIVEIS)="data">
                  <span :class="data.value < 0 ? 'text-danger font-weight-bold' : 'text-success'">
                    {{ data.value }}
                  </span>
                </template>

                <!-- Ícone de ação: seta para expandir etiquetas -->
                <template #cell(DETALHE)="row">
                  <i 
                    :class="row.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                    @click.stop="toggleDetalhesEstoque(row)"
                    :style="{ cursor: 'pointer' }"
                  ></i>
                </template>

                <!-- Detalhes: Dependendo da visão, Etiquetas ou Sub-tabela de Produtos -->
                <template #row-details="row">
                  <!-- Visão Produto: Mostra etiquetas diretamente -->
                  <template v-if="visaoAtual === 'produto'">
                    <div v-if="row.item.loading" class="text-center py-3">
                      <b-spinner small variant="primary"></b-spinner> Carregando etiquetas...
                    </div>
                    <div v-else-if="!row.item.etiquetas || row.item.etiquetas.length === 0" class="text-center py-3 text-muted">
                      <i class="fa fa-inbox"></i> Nenhuma etiqueta encontrada
                    </div>
                    <div v-else>
                      <b-table 
                        head-variant="dark"
                        :hover="false"
                        :table-variant="isDark ? 'primary' : 'light'"
                        :items="row.item.etiquetas" 
                        :fields="tabelaEtiquetas.fields"
                        small
                        responsive>
                      </b-table>
                    </div>
                  </template>

                  <!-- Visão Grupo/Vencimento: Mostra sub-tabela com os produtos agrupados -->
                  <template v-else>
                    <div class="p-3 bg-light rounded shadow-sm border mb-3 mx-2" :class="{'bg-dark text-white border-secondary': isDark}">
                      <h6 class="mb-3 font-weight-bold" :class="isDark ? 'text-info' : 'text-primary'">
                        <i class="fa" :class="visaoAtual === 'grupo' ? 'fa-folder-open' : 'fa-calendar'"></i>
                        {{ visaoAtual === 'grupo' ? 'Produtos do Grupo: ' + row.item.DESCRICAO_GRUPO : 'Produtos com Vencimento: ' + formatarData(row.item.VALIDADE) }}
                      </h6>

                      <b-table
                        class="modern-premium-table nested-products-table bg-white border rounded"
                        :class="{'table-dark border-secondary': isDark}"
                        :items="row.item.produtos"
                        :fields="camposProdutosAgrupados"
                        hover
                        small
                        responsive
                      >
                        <!-- Formatação de valores monetários na sub-tabela -->
                        <template #cell(VL_CUSTO)="data">
                          {{ formatarMoeda(data.value) }}
                        </template>

                        <template #cell(VL_VENDA)="data">
                          {{ formatarMoeda(data.value) }}
                        </template>

                        <!-- Formatação de datas na sub-tabela -->
                        <template #cell(VALIDADE)="data">
                          {{ formatarData(data.value) }}
                        </template>

                        <!-- Peças disponível vs reservado na sub-tabela -->
                        <template #cell(PECAS_DISPONIVEIS)="data">
                          <span :class="data.value < 0 ? 'text-danger font-weight-bold' : 'text-success'">
                            {{ data.value }}
                          </span>
                        </template>

                        <!-- Ícone de ação: seta para expandir etiquetas na sub-tabela -->
                        <template #cell(DETALHE)="subRow">
                          <i 
                            :class="subRow.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                            @click.stop="toggleDetalhesEstoque(subRow)"
                            :style="{ cursor: 'pointer' }"
                          ></i>
                        </template>

                        <!-- Detalhes no segundo nível: etiquetas do produto -->
                        <template #row-details="subRow">
                          <div v-if="subRow.item.loading" class="text-center py-3">
                            <b-spinner small variant="primary"></b-spinner> Carregando etiquetas...
                          </div>
                          <div v-else-if="!subRow.item.etiquetas || subRow.item.etiquetas.length === 0" class="text-center py-3 text-muted">
                            <i class="fa fa-inbox"></i> Nenhuma etiqueta encontrada
                          </div>
                          <div v-else>
                            <b-table 
                              head-variant="dark"
                              :hover="false"
                              :table-variant="isDark ? 'primary' : 'light'"
                              :items="subRow.item.etiquetas" 
                              :fields="tabelaEtiquetas.fields"
                              small
                              responsive>
                            </b-table>
                          </div>
                        </template>

                        <!-- Ações na sub-tabela -->
                        <template #cell(actions)="subRow">
                          <div class="d-flex gap-1">
                            <b-button  
                              @click.stop="abrirModalReservados(subRow.item)"
                              size="sm" 
                              variant="soft-success" 
                              class="btn-action-icon"
                              title="Ver Pedidos Reservados" 
                              v-b-tooltip.hover.left
                              v-if="subRow.item.PECAS_RESERVADO > 0 || subRow.item.QUANT_RESERVADA_PRODUCAO > 0"
                            >
                              <i class="fa fa-eye"></i>
                            </b-button>
                            <b-button  
                              @click.stop="abrirModalSaldoCentros(subRow.item)"
                              size="sm" 
                              variant="soft-warning" 
                              class="btn-action-icon"
                              title="Saldo em Todos os Centros" 
                              v-b-tooltip.hover.left
                            >
                              <i class="fa fa-building"></i>
                            </b-button>
                            <b-button
                              @click.stop="abrirModalLotes(subRow.item)"
                              size="sm"
                              variant="soft-secondary"
                              class="btn-action-icon"
                              title="Lotes"
                              v-b-tooltip.hover.left
                            >
                              <i class="fa fa-clone"></i>
                            </b-button>
                            <b-button  
                              @click.stop="abrirModalTrilha(subRow)"
                              size="sm" 
                              variant="soft-info" 
                              class="btn-action-icon"
                              title="Trilha de Auditoria" 
                              v-b-tooltip.hover.left
                            >
                              <i class="fa fa-info"></i>
                            </b-button>
                          </div>
                        </template>
                      </b-table>
                    </div>
                  </template>
                </template>

                <!-- Rodapé de Totais Gerais da Tabela Principal -->
                <template #custom-foot>
                  <tr class="font-weight-bold" :class="isDark ? 'bg-secondary text-white' : 'bg-light text-dark'" style="border-top: 2px solid #ccc;">
                    <td v-for="field in camposTabelaExibidos" :key="'foot-' + field.key" :class="field.class || ''" class="py-2 align-middle">
                      <span v-if="field.key === 'PRODUTO_ID' || field.key === 'ID_GRUPO' || (visaoAtual === 'vencimento' && field.key === 'VALIDADE')">
                        TOTAL:
                      </span>
                      <span v-else-if="field.key === 'DESCRICAO' || field.key === 'DESCRICAO_GRUPO'">
                        {{ totalRows }} itens
                      </span>
                      <span v-else-if="field.key === 'PECAS'">
                        {{ totalGeralPecas }}
                      </span>
                      <span v-else-if="field.key === 'QUANT'">
                        {{ formatarPeso(totalGeralQuantidade) }}
                      </span>
                      <span v-else-if="field.key === 'PECAS_RESERVADO'">
                        {{ totalGeralPecasReservado }}
                      </span>
                      <span v-else-if="field.key === 'QUANT_RESERVADA_PRODUCAO'">
                        {{ formatarPeso(totalGeralQuantReservada) }}
                      </span>
                      <span v-else-if="field.key === 'PECAS_DISPONIVEIS'">
                        {{ totalGeralPecasDisponiveis }}
                      </span>
                      <span v-else-if="field.key === 'QUANT_DISPONIVEL'">
                        {{ formatarPeso(totalGeralQuantDisponivel) }}
                      </span>
                      <span v-else-if="field.key === 'VL_CUSTO'">
                        {{ formatarMoeda(totalGeralCusto) }}
                      </span>
                      <span v-else-if="field.key === 'VL_VENDA'">
                        {{ formatarMoeda(totalGeralVenda) }}
                      </span>
                      <span v-else>
                        <!-- Vazio -->
                      </span>
                    </td>
                  </tr>
                </template>

                <template #cell(actions)="row">
                  <div class="d-flex gap-1">
                    <b-button  
                              @click.stop="abrirModalReservados(row.item)"
                              size="sm" 
                              variant="soft-success" 
                              class="btn-action-icon"
                              title="Ver Pedidos Reservados" 
                              v-b-tooltip.hover.left
                              v-if="row.item.PECAS_RESERVADO > 0 || row.item.QUANT_RESERVADA_PRODUCAO > 0"
                    >
                      <i class="fa fa-eye"></i>
                    </b-button>
                    <b-button  
                              @click.stop="abrirModalSaldoCentros(row.item)"
                              size="sm" 
                              variant="soft-warning" 
                              class="btn-action-icon"
                              title="Saldo em Todos os Centros" 
                              v-b-tooltip.hover.left
                    >
                      <i class="fa fa-building"></i>
                    </b-button>
                    <b-button
                              @click.stop="abrirModalLotes(row.item)"
                              size="sm"
                              variant="soft-secondary"
                              class="btn-action-icon"
                              title="Lotes"
                              v-b-tooltip.hover.left
                    >
                      <i class="fa fa-clone"></i>
                    </b-button>
                    <b-button  
                              @click.stop="abrirModalTrilha(row)"
                              size="sm" 
                              variant="soft-info" 
                              class="btn-action-icon"
                              title="Trilha de Auditoria" 
                              v-b-tooltip.hover.left
                    >
                      <i class="fa fa-info"></i>
                    </b-button>
                  </div>
                </template>

            </b-table>
          </div>
        </b-col>
      </b-row>

    <!--  -----------------------------------------------------------------------------------
                                    MODAL PEDIDOS RESERVADOS
      ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-reservados" 
          id="modal-reservados" 
          hide-header
          hide-footer
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          centered
          size="xl"
          scrollable
      >
        <!-- Header Premium -->
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark modal-header-gradient-success">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-shopping-cart text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Pedidos Reservados</h5>
              <small class="text-white opacity-75">Reservas de venda e bloqueios de produção por fórmula</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-reservados')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <!-- Info Bar -->
        <div class="modal-info-bar mb-0 bg-light border-bottom shadow-sm p-3">
            <b-row align-v="center">
                <b-col md="1" class="text-center">
                    <small class="modal-label-premium">ID</small>
                    <h6 class="mb-0 font-weight-bold text-primary">{{dadosModalReservados.produtoId}}</h6>
                </b-col>
                <b-col md="6" class="border-left">
                    <small class="modal-label-premium">Produto</small>
                    <h6 class="mb-0 font-weight-bold text-dark">{{dadosModalReservados.nomeProduto}}</h6>
                </b-col>
                <b-col md="2" class="border-left">
                    <small class="modal-label-premium">Centro Estoque</small>
                    <h6 class="mb-0 font-weight-bold text-dark">{{dadosModalReservados.centroEstoque}}</h6>
                </b-col>
                <b-col md="2" class="border-left text-center">
                    <small class="modal-label-premium">Total Reservado</small>
                    <div class="d-flex align-items-center justify-content-center">
                        <div class="mr-3">
                            <h5 class="mb-0 font-weight-bold text-danger">{{dadosModalReservados.totalReservado}}</h5>
                            <small class="text-muted">peças</small>
                        </div>
                        <div>
                            <h5 class="mb-0 font-weight-bold text-warning">{{formatarPeso(dadosModalReservados.totalPesoReservado)}}</h5>
                            <small class="text-muted">Quantidade</small>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>

        <!-- Tabela de Pedidos -->
        <div class="p-4 modal-content-scroll">
          <div class="modal-section-title mb-3">
            <i class="fa fa-list mr-2 text-success"></i> Pedidos com Reservas
          </div>
          
          <b-table 
            striped 
            hover 
            show-empty
            empty-text="Nenhum pedido com reserva"
            stacked="md"
            small
            responsive 
            head-variant="dark"
            class="modern-premium-table mb-0"
            :items="dadosModalReservados.pedidos" 
            :fields="dadosModalReservados.colunas">

              <template #cell(SITUACAO)="data">
                <b-badge pill :variant="variantSituacao(data.value)">{{ descricaoSituacao(data.value) }}</b-badge>
              </template>

              <template #cell(DT_PEDIDO)="data">
                {{ formatarData(data.value) }}
              </template>

          </b-table>

          <div class="modal-section-title mb-3 mt-4">
            <i class="fa fa-industry mr-2 text-warning"></i> Processos de Produção em Lançamento
          </div>

          <b-table
            striped
            hover
            show-empty
            empty-text="Nenhum processo de produção reservando saldo"
            stacked="md"
            small
            responsive
            head-variant="dark"
            class="modern-premium-table mb-0"
            :items="dadosModalReservados.processos"
            :fields="dadosModalReservados.colunasProcessos">

              <template #cell(QUANTIDADE_RESERVADA)="data">
                {{ formatarPeso(data.value) }}
              </template>

              <template #cell(PECAS_RESERVADAS)="data">
                <span class="font-weight-bold text-warning">{{ data.value || 0 }}</span>
              </template>

              <template #cell(SITUACAO)="data">
                <b-badge pill :variant="variantSituacaoProcesso(data.value)">{{ descricaoSituacaoProcesso(data.value) }}</b-badge>
              </template>

          </b-table>
        </div>

        <!-- Footer Premium -->
        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button variant="soft-danger" pill class="px-5 font-weight-bold" @click="$bvModal.hide('modal-reservados')">
            <i class="fa fa-times mr-1"></i> FECHAR
          </b-button>
        </div>
      </b-modal>

    <!--  -----------------------------------------------------------------------------------
                                    MODAL TRILHA DE AUDITORIA PREMIUM
      ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-trilha" 
          id="modal-trilha" 
          hide-header
          hide-footer
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          centered
          size="xl"
          scrollable
      >
        <!-- Header Premium -->
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark modal-header-gradient-purple">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-history text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Trilha de Auditoria</h5>
                <small class="text-white opacity-75">Histórico completo de movimentações do produto</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-trilha')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <!-- Info Bar -->
        <div class="modal-info-bar mb-0 bg-light border-bottom shadow-sm p-3">
            <b-row align-v="center">
                <b-col md="1" class="text-center">
                    <small class="modal-label-premium">ID</small>
                    <h6 class="mb-0 font-weight-bold text-primary">{{dadosModalTrilha.produtoId}}</h6>
                </b-col>
                <b-col md="5" class="border-left">
                    <small class="modal-label-premium">Produto</small>
                    <h6 class="mb-0 font-weight-bold text-dark">{{dadosModalTrilha.nomeProduto}}</h6>
                </b-col>
                <b-col md="3" class="border-left">
                    <small class="modal-label-premium">Centro de Estoque</small>
                    <h6 class="mb-0 font-weight-bold text-dark">{{dadosModalTrilha.nomeCentroEstoque}}</h6>
                </b-col>
                <b-col md="3" class="border-left text-center">
                    <small class="modal-label-premium">Saldo Atual</small>
                    <h5 class="mb-0 font-weight-bold text-success">{{dadosModalTrilha.saldoAtual}}</h5>
                    <small class="text-muted font-weight-bold">Inv: {{dadosModalTrilha.dataInventario}}</small>
                </b-col>
            </b-row>
        </div>

        <!-- Tabela de Movimentações -->
        <div class="p-4 modal-content-scroll">
          <div class="modal-section-title mb-3">
            <i class="fa fa-list-alt mr-2 text-primary"></i> Movimentações do Estoque
          </div>
          
          <b-table 
            striped 
            hover 
            show-empty
            empty-text="Nenhum lançamento do Produto"
            stacked="md"
            small
            responsive 
            head-variant="dark"
            class="modern-premium-table mb-0"
            :items="dadosModalTrilha.tabela.items" 
            :fields="dadosModalTrilha.tabela.colunas">

              <template #cell(TIPO)="item">
                <b-badge pill :variant="colorirTipoTrilha(item.item)">{{item.item.TIPO}}</b-badge>
              </template>      

          </b-table>
        </div>

        <!-- Footer Premium -->
        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button variant="soft-danger" pill class="px-5 font-weight-bold" @click="$bvModal.hide('modal-trilha')">
            <i class="fa fa-times mr-1"></i> FECHAR
          </b-button>
        </div>
      </b-modal>

    <!--  -----------------------------------------------------------------------------------
                                    MODAL LOTES DO ESTOQUE
      ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-lotes"
          id="modal-lotes"
          hide-header
          hide-footer
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          centered
          size="xl"
          scrollable
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark modal-header-gradient-secondary">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-clone text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Detalhamento por Lote</h5>
                <small class="text-white opacity-75">Lotes com saldo do produto no centro selecionado</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-lotes')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="modal-info-bar mb-0 bg-light border-bottom shadow-sm p-3">
            <b-row align-v="center">
                <b-col md="1" class="text-center">
                    <small class="modal-label-premium">ID</small>
                    <h6 class="mb-0 font-weight-bold text-primary">{{dadosModalLotes.produtoId}}</h6>
                </b-col>
                <b-col md="6" class="border-left">
                    <small class="modal-label-premium">Produto</small>
                    <h6 class="mb-0 font-weight-bold text-dark">{{dadosModalLotes.nomeProduto}}</h6>
                </b-col>
                <b-col md="3" class="border-left">
                    <small class="modal-label-premium">Centro de Estoque</small>
                    <h6 class="mb-0 font-weight-bold text-dark">{{dadosModalLotes.nomeCentroEstoque}}</h6>
                </b-col>
                <b-col md="2" class="border-left text-center">
                    <small class="modal-label-premium">Total Lotes</small>
                    <h5 class="mb-0 font-weight-bold text-secondary">{{dadosModalLotes.items.length}}</h5>
                </b-col>
            </b-row>
        </div>

        <div class="p-4 modal-content-scroll">
          <div class="modal-section-title mb-3">
            <i class="fa fa-list mr-2 text-secondary"></i> Lotes Disponíveis
          </div>

          <b-table
            striped
            hover
            show-empty
            empty-text="Nenhum lote com saldo encontrado para o produto"
            stacked="md"
            small
            responsive
            head-variant="dark"
            class="modern-premium-table mb-0"
            :items="dadosModalLotes.items"
            :fields="dadosModalLotes.colunas">

              <template #cell(DATA_FABRICACAO)="data">
                {{ formatarData(data.value) }}
              </template>

              <template #cell(DATA_VALIDADE)="data">
                {{ formatarData(data.value) }}
              </template>

              <template #cell(QUANT_INICIAL)="data">
                {{ formatarPeso(data.value) }}
              </template>

              <template #cell(QUANT_SALDO)="data">
                <span class="font-weight-bold text-success">{{ formatarPeso(data.value) }}</span>
              </template>

              <template #cell(PECAS_SALDO)="data">
                <span class="font-weight-bold text-warning">{{ data.value || 0 }}</span>
              </template>

              <template #cell(VL_CUSTO_UNITARIO)="data">
                {{ formatarMoeda(data.value) }}
              </template>

              <template #cell(OP_ORIGEM)="data">
                {{ formatarOrigemLote(data.value) }}
              </template>

              <template #cell(OBSERVACAO)="data">
                <span>{{ data.value || '-' }}</span>
              </template>

          </b-table>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button variant="soft-danger" pill class="px-5 font-weight-bold" @click="$bvModal.hide('modal-lotes')">
            <i class="fa fa-times mr-1"></i> FECHAR
          </b-button>
        </div>
      </b-modal>

    <!--  -----------------------------------------------------------------------------------
                                    MODAL SALDO EM TODOS OS CENTROS DE ESTOQUE
      ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-saldo-centros" 
          id="modal-saldo-centros" 
          hide-header
          hide-footer
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          centered
          size="xl"
          scrollable
      >
        <!-- Header Premium -->
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark modal-header-gradient-warning">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-building text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Saldo em Todos os Centros de Estoque</h5>
                <small class="text-white opacity-75">Visualização completa do estoque nos centros</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-saldo-centros')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <!-- Info Bar -->
        <div class="modal-info-bar mb-0 bg-light border-bottom shadow-sm p-3">
            <b-row align-v="center" class="mb-2">
                <b-col md="1" class="text-center">
                    <small class="modal-label-premium">ID</small>
                    <h6 class="mb-0 font-weight-bold text-primary">{{dadosModalSaldoCentros.produtoId}}</h6>
                </b-col>
                <b-col md="11" class="border-left">
                    <small class="modal-label-premium">Produto</small>
                    <h6 class="mb-0 font-weight-bold text-dark">{{dadosModalSaldoCentros.nomeProduto}}</h6>
                </b-col>
            </b-row>
            <hr class="my-2">
            <b-row align-v="center">
                <b-col v-if="opVendaPorPecas !== 'N'" md="2" class="text-center border-right">
                    <small class="modal-label-premium">Total Volumes</small>
                    <h5 class="mb-0 font-weight-bold text-warning">{{dadosModalSaldoCentros.totalPecas}}</h5>
                    <small class="text-muted">peças</small>
                </b-col>
                <b-col md="2" class="text-center border-right">
                    <small class="modal-label-premium">Total Peso</small>
                    <h5 class="mb-0 font-weight-bold text-info">{{formatarPeso(dadosModalSaldoCentros.totalPeso)}}</h5>
                    <small class="text-muted">Quantidade</small>
                </b-col>
                <b-col md="2" class="text-center border-right">
                    <small class="modal-label-premium">Total Reservado</small>
                    <div class="d-flex align-items-center justify-content-center">
                        <div v-if="opVendaPorPecas !== 'N'" class="mr-2">
                            <h5 class="mb-0 font-weight-bold text-warning">{{dadosModalSaldoCentros.totalReservado}}</h5>
                            <small class="text-muted">peças</small>
                        </div>
                        <div>
                            <h5 class="mb-0 font-weight-bold text-warning">{{formatarPeso(dadosModalSaldoCentros.totalPesoReservado)}}</h5>
                            <small class="text-muted">Quantidade</small>
                        </div>
                    </div>
                </b-col>
                <b-col md="2" class="text-center border-right">
                    <small class="modal-label-premium">Total Disponível</small>
                    <div class="d-flex align-items-center justify-content-center">
                        <div v-if="opVendaPorPecas !== 'N'" class="mr-2">
                            <h5 class="mb-0 font-weight-bold text-success">{{dadosModalSaldoCentros.totalDisponivel}}</h5>
                            <small class="text-muted">peças</small>
                        </div>
                        <div>
                            <h5 class="mb-0 font-weight-bold text-success">{{formatarPeso(dadosModalSaldoCentros.totalPesoDisponivel)}}</h5>
                            <small class="text-muted">Quantidade</small>
                        </div>
                    </div>
                </b-col>
                <b-col md="2" class="text-center border-right">
                    <small class="modal-label-premium">Total Custo</small>
                    <h5 class="mb-0 font-weight-bold text-primary">{{formatarMoeda(dadosModalSaldoCentros.totalCusto)}}</h5>
                </b-col>
                <b-col md="2" class="text-center">
                    <small class="modal-label-premium">Total Venda</small>
                    <h5 class="mb-0 font-weight-bold text-success">{{formatarMoeda(dadosModalSaldoCentros.totalVenda)}}</h5>
                </b-col>
            </b-row>
        </div>

        <!-- Tabela de Saldos por Centro -->
        <div class="p-4 modal-content-scroll">
          <div class="modal-section-title mb-3">
            <i class="fa fa-warehouse mr-2 text-warning"></i> Estoque por Centro
          </div>
          
          <b-table 
            striped 
            hover 
            show-empty
            empty-text="Nenhum estoque encontrado"
            stacked="md"
            small
            responsive 
            head-variant="dark"
            class="modern-premium-table mb-0"
            :items="dadosModalSaldoCentros.centros" 
            :fields="dadosModalSaldoCentros.colunas">

              <template #cell(QUANT)="data">
                {{ formatarPeso(data.value) }}
              </template>

              <template #cell(QUANT_RESERVADA_PRODUCAO)="data">
                <span class="text-warning font-weight-bold" v-if="data.value > 0">
                  {{ formatarPeso(data.value) }}
                </span>
                <span v-else>{{ formatarPeso(data.value) }}</span>
              </template>

              <template #cell(PECAS_DISPONIVEIS)="data">
                <span :class="data.value < 0 ? 'text-danger font-weight-bold' : 'text-success font-weight-bold'">
                  {{ data.value }}
                </span>
              </template>

              <template #cell(PECAS_RESERVADO)="data">
                <span class="text-warning font-weight-bold" v-if="data.value > 0">
                  {{ data.value }}
                </span>
                <span v-else>{{ data.value }}</span>
              </template>

              <template #cell(VL_CUSTO)="data">
                {{ formatarMoeda(data.value) }}
              </template>

              <template #cell(VL_VENDA)="data">
                {{ formatarMoeda(data.value) }}
              </template>

          </b-table>
        </div>

        <!-- Footer Premium -->
        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button variant="soft-danger" pill class="px-5 font-weight-bold" @click="$bvModal.hide('modal-saldo-centros')">
            <i class="fa fa-times mr-1"></i> FECHAR
          </b-button>
        </div>
      </b-modal>

    </div>
  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'
import ProdutoPesquisa from '../pesquisa/ProdutoPesquisa.vue'
import ClientePesquisa from '../pesquisa/ClientePesquisa.vue'
import GrupoProdutoPesquisa from '../pesquisa/GrupoProdutoPesquisa.vue'
import SetFilter from '@/components/Cec/SetFilter.vue'
import Tools from '@/tools/tools.js'
import moment from 'moment'
import {Money} from 'v-money'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'EstoqueDiversos',
  components: {
    VueButtonSpinner,
    ProdutoPesquisa,
    ClientePesquisa,
    GrupoProdutoPesquisa,
    Money,
    SetFilter
  },
  mixins: [createCecTableToolsMixin({
     rowsProp: 'LISTA', 
     tblRef: 'tbl',
     perPageDefault: 500,
     filters: [
        { key: 'PRODUTO_ID', type: 'string', label: 'Id' },
        { key: 'DESCRICAO', type: 'string', label: 'Produto' },
        { key: 'DESCRICAO_CENTRO_ESTOQUE', type: 'string', label: 'Centro de Estoque' }
     ]
  })],
  data () {
    return {
      visaoAtual: 'produto',
      gruposExpandidos: {},
      vencimentosExpandidos: {},
      filtroAvancado: false,
      isBusy: false,
      opVendaPorPecas: 'S',
      opEstoqueEtiquetado: '0',
      centroEstoqueOptions: [],
      tabelaEtiquetas: {
        fields: [
          {
            key: "NUMERO_CAIXA",
            label: 'Número Caixa',
            sortable: true,
            thStyle: { width: '15%' }
          },
          {
            key: "CODIGO_INTERNO",
            label: 'Código Interno',
            sortable: true,
            thStyle: { width: '15%' }
          },
          {
            key: "CODIGO_BARRAS",
            label: 'Código Barras',
            sortable: true,
            thStyle: { width: '15%' }
          },
          {
            key: "PESO",
            label: 'Quantidade',
            sortable: true,
            class: 'text-right',
            thStyle: { width: '10%' },
            formatter: (value) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: "PECAS",
            label: 'Peças Caixa',
            sortable: true,
            class: 'text-right',
            thStyle: { width: '10%' }
          },
          {
            key: "DATA",
            label: 'Data',
            sortable: true,
            thStyle: { width: '12%' },
            formatter: (value) => value ? moment(value).format('DD/MM/YYYY') : ''
          },
          {
            key: "VALIDADE",
            label: 'Validade',
            sortable: true,
            thStyle: { width: '12%' },
            formatter: (value) => value ? moment(value).format('DD/MM/YYYY') : ''
          },
          {
            key: "NOME_CLIENTE",
            label: 'Fornecedor',
            sortable: true,
            thStyle: { width: '20%' }
          }
        ]
      },
      dadosModalTrilha: {
        produtoId: '',
        nomeProduto: '',
        centroEstoqueId: '',
        nomeCentroEstoque: '',
        saldoAtual: '',
        dataInventario: '',
        tabela: {
          items: [],
          colunas: [
            {
              key: "AUX_ID",
              label: 'Controle Id',
              sortable: true,
              thStyle: { width: '10% !important'},
              visible: true
            },
            {
              key: "NOME_CLIENTE",
              label: 'Cliente',
              sortable: true,
              thStyle: { width: '25% !important'},
              visible: true
            },
            {
              key: "DIA",
              label: 'Data', 
              sortable: true,
              formatter: (value, key, item) => 
                moment(String(value)).format('DD/MM/YYYY')
            },
            {
              key: "TIPO",
              label: 'Tipo',
              sortable: true,
              thStyle: { width: '15% !important'},
              visible: true
            },
            {
              key: "PECAS",
              label: 'Peças',
              class:'text-right',
              sortable: true,
              thStyle: { width: '15% !important'},
              visible: true,
              formatter: (value, key, item) => 
                (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})  
            },
            {
              key: "SALDO_PECAS",
              label: 'Saldo. Peças',
              class:'text-right',
              sortable: true,
              thStyle: { width: '15% !important'},
              visible: true,
              formatter: (value, key, item) => 
                (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})  
            },
            {
              key: "QUANT",
              label: 'Quantidade',
              class:'text-right',
              sortable: true,
              thStyle: { width: '15% !important'},
              visible: true,
              formatter: (value, key, item) => 
                (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})  
            },
            {
              key: "SALDO",
              label: 'Saldo Quantidade',
              class:'text-right',
              sortable: true,
              thStyle: { width: '15% !important'},
              visible: true,
              formatter: (value, key, item) => 
                (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})  
            }
          ]
        }
      },
       // Definição das colunas da tabela principal

      dadosModalReservados: {
        produtoId: '',
        nomeProduto: '',
        centroEstoque: '',
        totalReservado: 0,
        totalPesoReservado: 0,
        pedidos: [],
        processos: [],
        colunas: [
          {
            key: "SEQUENCIA",
            label: 'Pedido',
            sortable: true,
            thStyle: { width: '10%' }
          },
          {
            key: "CLIENTE_ID",
            label: 'Cód. Cliente',
            sortable: true,
            thStyle: { width: '10%' }
          },
          {
            key: "NOME_CLIENTE",
            label: 'Cliente',
            sortable: true,
            thStyle: { width: '30%' }
          },
          {
            key: "NOME_VENDEDOR",
            label: 'Vendedor',
            sortable: true,
            thStyle: { width: '20%' }
          },
          {
            key: "DT_PEDIDO",
            label: 'Data Pedido',
            sortable: true,
            thStyle: { width: '12%' }
          },
          {
            key: "SITUACAO",
            label: 'Situação',
            sortable: true,
            thStyle: { width: '10%' }
          },
          {
            key: "PECAS_PEDIDO",
            label: 'Peças',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '8%' }
          }
        ],
        colunasProcessos: [
          {
            key: "PROCESSO_ID",
            label: 'Processo ID',
            sortable: true,
            thStyle: { width: '10%' }
          },
          {
            key: "LOTE",
            label: 'Lote',
            sortable: true,
            thStyle: { width: '12%' }
          },
          {
            key: "FORMULA_DESCRICAO",
            label: 'Fórmula',
            sortable: true,
            thStyle: { width: '24%' }
          },
          {
            key: "CENTRO_ESTOQUE_CODIGONOME",
            label: 'Centro de Estoque',
            sortable: true,
            thStyle: { width: '20%' }
          },
          {
            key: "QUANTIDADE_RESERVADA",
            label: 'Quantidade Reservada',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '12%' }
          },
          {
            key: "PECAS_RESERVADAS",
            label: 'Peças Reservadas',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '10%' }
          },
          {
            key: "SITUACAO",
            label: 'Situação',
            sortable: true,
            thStyle: { width: '12%' }
          }
        ]
      },
      dadosModalSaldoCentros: {
        produtoId: '',
        nomeProduto: '',
        totalPecas: 0,
        totalPeso: 0,
        totalPesoReservado: 0,
        totalPesoDisponivel: 0,
        totalReservado: 0,
        totalDisponivel: 0,
        totalCusto: 0,
        totalVenda: 0,
        centros: [],
        colunas: [
          {
            key: "DESCRICAO_CENTRO_ESTOQUE",
            label: 'Centro de Estoque',
            sortable: true,
            thStyle: { width: '25%' }
          },
          {
            key: "PECAS",
            label: 'Volumes',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '10%' }
          },
          {
            key: "QUANT",
            label: 'Quantidade',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '12%' }
          },
          {
            key: "MEDIA_ESTOQUE",
            label: 'Media',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '8%' },
            formatter: (value) =>
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: "QUANT_RESERVADA_PRODUCAO",
            label: 'Quant. Reserv.',
            class: 'text-right text-warning',
            sortable: true,
            thStyle: { width: '10%' },
            formatter: (value) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})
          },
          {
            key: "QUANT_DISPONIVEL",
            label: 'Quant. Disp.',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '10%' },
            formatter: (value, key, item) => {
               const quant = Number(item.QUANT || 0)
               const reserva = Number(item.QUANT_RESERVADA_PRODUCAO || 0)
               return (quant - reserva).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})
            }
          },
          {
            key: "PECAS_DISPONIVEIS",
            label: 'Disp. Vol',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '10%' }
          },
          {
            key: "VL_CUSTO",
            label: 'Vl. Custo',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '12%' }
          },
          {
            key: "VL_VENDA",
            label: 'Vl. Venda',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '12%' }
          },
          {
            key: "UND_ENT",
            label: 'UND',
            class: 'text-center',
            sortable: true,
            thStyle: { width: '9%' }
          }
        ]
      },
      dadosModalLotes: {
        produtoId: '',
        nomeProduto: '',
        nomeCentroEstoque: '',
        items: [],
        colunas: [
          {
            key: 'LOTE',
            label: 'Lote',
            sortable: true,
            thStyle: { width: '10%' }
          },
          {
            key: 'LOTE_FORNECEDOR',
            label: 'Lote Fornecedor',
            sortable: true,
            thStyle: { width: '12%' }
          },
          {
            key: 'DATA_FABRICACAO',
            label: 'Data Fabricação',
            sortable: true,
            thStyle: { width: '10%' }
          },
          {
            key: 'DATA_VALIDADE',
            label: 'Data Validade',
            sortable: true,
            thStyle: { width: '10%' }
          },
          {
            key: 'QUANT_INICIAL',
            label: 'Quantidade Inicial',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '10%' }
          },
          {
            key: 'QUANT_SALDO',
            label: 'Quantidade Saldo',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '10%' }
          },
          {
            key: 'PECAS_SALDO',
            label: 'Peças Saldo',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '8%' }
          },
          {
            key: 'VL_CUSTO_UNITARIO',
            label: 'Custo Unitário',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '10%' }
          },
          {
            key: 'OP_ORIGEM',
            label: 'Origem',
            sortable: true,
            thStyle: { width: '8%' }
          },
          {
            key: 'OBSERVACAO',
            label: 'Observação',
            sortable: true,
            thStyle: { width: '12%' }
          }
        ]
      }
    }
  },
  
  computed: {
    ...mapGetters('estoqueDiversos', ['LISTA', 'CENTRO_ESTOQUE_ID', 'PRODUTO_ID', 'GRUPO_PRODUTO_ID', 'EXIBIR_ZERADOS']),
    ...mapGetters('tema', ['IS_DARK']),
    isDark() {
      // Tenta pegar do módulo tema, se não existir fallback para local storage ou false
      return this.IS_DARK || false
    },
    centroEstoqueIdLocal: {
        get() { return this.CENTRO_ESTOQUE_ID },
        set(val) { this.SET_CENTRO_ESTOQUE_ID(val) }
    },
    produtoIdLocal: {
        get() { return this.PRODUTO_ID },
        set(val) { this.SET_PRODUTO_ID(val) }
    },
    grupoProdutoIdLocal: {
        get() { return this.GRUPO_PRODUTO_ID },
        set(val) { this.SET_GRUPO_PRODUTO_ID(val) }
    },
    exibirZeradosLocal: {
        get() { return this.EXIBIR_ZERADOS },
        set(val) { this.SET_EXIBIR_ZERADOS(val) }
    },
    totalRows() {
      if (this.visaoAtual === 'grupo') {
        return this.itensAgrupadosPorGrupo.length
      } else if (this.visaoAtual === 'vencimento') {
        return this.itensAgrupadosPorVencimento.length
      }
      return this.itensFiltrados.length
    },
    itensAgrupadosPorGrupo() {
      const grupos = {}
      for (const item of this.itensFiltrados) {
        const grupoId = item.ID_GRUPO || 0
        const grupoDesc = item.DESCRICAO_GRUPO || 'Sem Grupo'
        const key = `${grupoId}`
        if (!grupos[key]) {
          grupos[key] = {
            ID_GRUPO: grupoId,
            DESCRICAO_GRUPO: grupoDesc,
            _showDetails: !!this.gruposExpandidos[grupoId],
            PECAS: 0,
            QUANT: 0,
            PECAS_RESERVADO: 0,
            QUANT_RESERVADA_PRODUCAO: 0,
            PECAS_DISPONIVEIS: 0,
            QUANT_DISPONIVEL: 0,
            VL_CUSTO: 0,
            VL_VENDA: 0,
            produtos: []
          }
        }
        const g = grupos[key]
        g.PECAS += Number(item.PECAS || 0)
        g.QUANT += Number(item.QUANT || 0)
        g.PECAS_RESERVADO += Number(item.PECAS_RESERVADO || 0)
        g.QUANT_RESERVADA_PRODUCAO += Number(item.QUANT_RESERVADA_PRODUCAO || 0)
        g.PECAS_DISPONIVEIS += Number(item.PECAS_DISPONIVEIS || 0)
        g.QUANT_DISPONIVEL += (Number(item.QUANT || 0) - Number(item.QUANT_RESERVADA_PRODUCAO || 0))
        g.VL_CUSTO += (Number(item.VL_CUSTO || 0) * Number(item.QUANT || 0))
        g.VL_VENDA += (Number(item.VL_VENDA || 0) * Number(item.QUANT || 0))
        g.produtos.push(item)
      }
      return Object.values(grupos)
    },
    itensAgrupadosPorVencimento() {
      const vencimentos = {}
      for (const item of this.itensFiltrados) {
        const val = item.VALIDADE || null
        const key = val ? moment(val).format('YYYY-MM-DD') : 'Sem Validade'
        if (!vencimentos[key]) {
          vencimentos[key] = {
            VALIDADE: val === null ? 'Sem Validade' : val,
            _showDetails: !!this.vencimentosExpandidos[key],
            PECAS: 0,
            QUANT: 0,
            PECAS_RESERVADO: 0,
            QUANT_RESERVADA_PRODUCAO: 0,
            PECAS_DISPONIVEIS: 0,
            QUANT_DISPONIVEL: 0,
            VL_CUSTO: 0,
            VL_VENDA: 0,
            produtos: []
          }
        }
        const v = vencimentos[key]
        v.PECAS += Number(item.PECAS || 0)
        v.QUANT += Number(item.QUANT || 0)
        v.PECAS_RESERVADO += Number(item.PECAS_RESERVADO || 0)
        v.QUANT_RESERVADA_PRODUCAO += Number(item.QUANT_RESERVADA_PRODUCAO || 0)
        v.PECAS_DISPONIVEIS += Number(item.PECAS_DISPONIVEIS || 0)
        v.QUANT_DISPONIVEL += (Number(item.QUANT || 0) - Number(item.QUANT_RESERVADA_PRODUCAO || 0))
        v.VL_CUSTO += (Number(item.VL_CUSTO || 0) * Number(item.QUANT || 0))
        v.VL_VENDA += (Number(item.VL_VENDA || 0) * Number(item.QUANT || 0))
        v.produtos.push(item)
      }
      const sortedKeys = Object.keys(vencimentos).sort((a, b) => {
        if (a === 'Sem Validade') return 1
        if (b === 'Sem Validade') return -1
        return new Date(a) - new Date(b)
      })
      return sortedKeys.map(k => vencimentos[k])
    },
    itensTabelaExibidos() {
      if (this.visaoAtual === 'grupo') {
        return this.itensAgrupadosPorGrupo
      } else if (this.visaoAtual === 'vencimento') {
        return this.itensAgrupadosPorVencimento
      }
      return this.itensFiltrados
    },
    camposTabelaExibidos() {
      if (this.visaoAtual === 'grupo') {
        const baseFields = [
          { key: 'DETALHE', label: '', thStyle: { width: '3%' }, tdClass: 'text-center' },
          { key: 'ID_GRUPO', label: 'Cód. Grupo', sortable: true, thStyle: { width: '8%' } },
          { key: 'DESCRICAO_GRUPO', label: 'Grupo de Produtos', sortable: true, thStyle: { width: '22%' } },
          { key: 'PECAS', label: 'Volumes', class: 'text-right', sortable: true, thStyle: { width: '8%' } },
          { key: 'QUANT', label: 'Quantidade', class: 'text-right', sortable: true, thStyle: { width: '10%' }, formatter: (value) => this.formatarPeso(value) },
          { key: 'PECAS_RESERVADO', label: 'Res. Vol', class: 'text-right text-warning', sortable: true, thStyle: { width: '8%' } },
          { key: 'QUANT_RESERVADA_PRODUCAO', label: 'Quant. Reserv.', class: 'text-right text-warning', sortable: true, thStyle: { width: '10%' }, formatter: (value) => this.formatarPeso(value) },
          { key: 'PECAS_DISPONIVEIS', label: 'Disp. Vol', class: 'text-right', sortable: true, thStyle: { width: '8%' } },
          { key: 'QUANT_DISPONIVEL', label: 'Quant. Disp.', class: 'text-right', sortable: true, thStyle: { width: '10%' }, formatter: (value) => this.formatarPeso(value) },
          { key: 'VL_CUSTO', label: 'Custo Total', class: 'text-right', sortable: true, thStyle: { width: '10%' }, formatter: (value) => this.formatarMoeda(value) },
          { key: 'VL_VENDA', label: 'Venda Total', class: 'text-right', sortable: true, thStyle: { width: '10%' }, formatter: (value) => this.formatarMoeda(value) }
        ]
        if (this.opVendaPorPecas === 'N') {
          return baseFields.filter(f => !['PECAS', 'PECAS_RESERVADO', 'PECAS_DISPONIVEIS'].includes(f.key))
        }
        return baseFields
      }
      if (this.visaoAtual === 'vencimento') {
        const baseFields = [
          { key: 'DETALHE', label: '', thStyle: { width: '3%' }, tdClass: 'text-center' },
          { key: 'VALIDADE', label: 'Data Validade', sortable: true, thStyle: { width: '20%' }, class: 'text-center', formatter: (value) => this.formatarData(value) },
          { key: 'PECAS', label: 'Volumes', class: 'text-right', sortable: true, thStyle: { width: '8%' } },
          { key: 'QUANT', label: 'Quantidade', class: 'text-right', sortable: true, thStyle: { width: '10%' }, formatter: (value) => this.formatarPeso(value) },
          { key: 'PECAS_RESERVADO', label: 'Res. Vol', class: 'text-right text-warning', sortable: true, thStyle: { width: '8%' } },
          { key: 'QUANT_RESERVADA_PRODUCAO', label: 'Quant. Reserv.', class: 'text-right text-warning', sortable: true, thStyle: { width: '10%' }, formatter: (value) => this.formatarPeso(value) },
          { key: 'PECAS_DISPONIVEIS', label: 'Disp. Vol', class: 'text-right', sortable: true, thStyle: { width: '8%' } },
          { key: 'QUANT_DISPONIVEL', label: 'Quant. Disp.', class: 'text-right', sortable: true, thStyle: { width: '10%' }, formatter: (value) => this.formatarPeso(value) },
          { key: 'VL_CUSTO', label: 'Custo Total', class: 'text-right', sortable: true, thStyle: { width: '10%' }, formatter: (value) => this.formatarMoeda(value) },
          { key: 'VL_VENDA', label: 'Venda Total', class: 'text-right', sortable: true, thStyle: { width: '10%' }, formatter: (value) => this.formatarMoeda(value) }
        ]
        if (this.opVendaPorPecas === 'N') {
          return baseFields.filter(f => !['PECAS', 'PECAS_RESERVADO', 'PECAS_DISPONIVEIS'].includes(f.key))
        }
        return baseFields
      }
      return this.fields
    },
    camposProdutosAgrupados() {
      const baseFields = [
        { key: "DETALHE", label: '', thStyle: { width: '3%' }, tdClass: 'text-center' },
        { key: "PRODUTO_ID", label: 'Id', sortable: true, thStyle: { width: '6%'} },
        { key: "DESCRICAO", label: 'Produto', sortable: true, thStyle: { width: '22%'} },
        { key: "DESCRICAO_CENTRO_ESTOQUE", label: 'Centro Estoque', sortable: true, thStyle: { width: '12%'} },
        { key: "UND_ENT", label: 'UND', sortable: true, thStyle: { width: '5%'}, class: 'text-center' },
        { key: "PECAS", label: 'Volumes', class:'text-right', sortable: true, thStyle: { width: '6%'} },
        { key: "QUANT", label: 'Quantidade', class:'text-right', sortable: true, thStyle: { width: '8%'}, formatter: (value) => this.formatarPeso(value) },
        { key: "PECAS_RESERVADO", label: 'Res. Vol', class:'text-right text-warning', sortable: true, thStyle: { width: '6%'} },
        { key: "QUANT_RESERVADA_PRODUCAO", label: 'Quant. Reserv.', class:'text-right text-warning', sortable: true, thStyle: { width: '8%'}, formatter: (value) => this.formatarPeso(value) },
        { key: "PECAS_DISPONIVEIS", label: 'Disp. Vol', class:'text-right', sortable: true, thStyle: { width: '6%'} },
        { key: "QUANT_DISPONIVEL", label: 'Quant. Disp.', class:'text-right', sortable: true, thStyle: { width: '8%'}, formatter: (value, key, item) => {
            const quant = Number(item.QUANT || 0)
            const reserva = Number(item.QUANT_RESERVADA_PRODUCAO || 0)
            return (quant - reserva).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})
          }
        },
        { key: "VL_CUSTO", label: 'Vl. Custo', class:'text-right', sortable: true, thStyle: { width: '8%'}, formatter: (value) => this.formatarMoeda(value) },
        { key: "VL_VENDA", label: 'Vl. Venda', class:'text-right', sortable: true, thStyle: { width: '8%'}, formatter: (value) => this.formatarMoeda(value) },
        { key: "VALIDADE", label: 'Validade', class:'text-center', sortable: true, thStyle: { width: '8%'}, formatter: (value) => this.formatarData(value) },
        { key: "actions", label: 'Ações', class:'text-center', thStyle: { width: "10%" } }
      ]
      if (this.opVendaPorPecas === 'N') {
        return baseFields.filter(f => !['PECAS', 'PECAS_RESERVADO', 'PECAS_DISPONIVEIS'].includes(f.key))
      }
      return baseFields
    },
    totalGeralPecas() {
      return this.itensFiltrados.reduce((acc, item) => acc + Number(item.PECAS || 0), 0)
    },
    totalGeralQuantidade() {
      return this.itensFiltrados.reduce((acc, item) => acc + Number(item.QUANT || 0), 0)
    },
    totalGeralPecasReservado() {
      return this.itensFiltrados.reduce((acc, item) => acc + Number(item.PECAS_RESERVADO || 0), 0)
    },
    totalGeralQuantReservada() {
      return this.itensFiltrados.reduce((acc, item) => acc + Number(item.QUANT_RESERVADA_PRODUCAO || 0), 0)
    },
    totalGeralPecasDisponiveis() {
      return this.itensFiltrados.reduce((acc, item) => acc + Number(item.PECAS_DISPONIVEIS || 0), 0)
    },
    totalGeralQuantDisponivel() {
      return this.itensFiltrados.reduce((acc, item) => {
        const quant = Number(item.QUANT || 0)
        const reserva = Number(item.QUANT_RESERVADA_PRODUCAO || 0)
        return acc + (quant - reserva)
      }, 0)
    },
    totalGeralCusto() {
      return this.itensFiltrados.reduce((acc, item) => acc + (Number(item.VL_CUSTO || 0) * Number(item.QUANT || 0)), 0)
    },
    totalGeralVenda() {
      return this.itensFiltrados.reduce((acc, item) => acc + (Number(item.VL_VENDA || 0) * Number(item.QUANT || 0)), 0)
    },
    fields() {
      const baseFields = [
          {
            key: "DETALHE",
            label: '',
            thStyle: { width: '2%' },
            tdClass: 'text-center'
          },
          {
            key: "PRODUTO_ID",
            label: 'Id',
            sortable: true,
            thStyle: { width: '4%'},
            visible: true
          },
          {
            key: "DESCRICAO",
            label: 'Produto',
            sortable: true ,
            thStyle: { width: '20%'} ,
            visible: true
          },
          {
            key: "DESCRICAO_CENTRO_ESTOQUE",
            label: 'Centro Estoque',
            sortable: true ,
            thStyle: { width: '12%' },
            visible: true
          },
          {
            key: "UND_ENT",
            label: 'UND',
            sortable: true,
            thStyle: { width: '4%'},
            visible: true,
            class: 'text-center'
          },
          {
            key: "PECAS",
            label: 'Volumes',
            class:'text-right', 
            sortable: true,
            thStyle: { width: '5%'},
            visible: true
          },
          {
            key: "QUANT",
            label: 'Quantidade',
            class:'text-right',
            sortable: true,
            thStyle: { width: '7%'},
            visible: true,
            formatter: (value, key, item) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})  
          },
          {
            key: "MEDIA_ESTOQUE",
            label: 'Media',
            class:'text-right',
            sortable: true,
            thStyle: { width: '5%'},
            visible: true,
            formatter: (value) =>
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: "PECAS_RESERVADO",
            label: 'Res. Vol',
            class:'text-right text-warning', 
            sortable: true,
            thStyle: { width: '5%'},
            visible: true
          },
          {
            key: "QUANT_RESERVADA_PRODUCAO",
            label: 'Quant. Reserv.',
            class:'text-right text-warning',
            sortable: true,
            thStyle: { width: '6%'},
            visible: true,
            formatter: (value) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})
          },
          {
            key: "PECAS_DISPONIVEIS",
            label: 'Disp. Vol',
            class:'text-right', 
            sortable: true,
            thStyle: { width: '5%'},
            visible: true
          },
          {
            key: "QUANT_DISPONIVEL",
            label: 'Quant. Disp.',
            class:'text-right',
            sortable: true,
            thStyle: { width: '6%'},
            visible: true,
            formatter: (value, key, item) => {
              const quant = Number(item.QUANT || 0)
              const reserva = Number(item.QUANT_RESERVADA_PRODUCAO || 0)
              return (quant - reserva).toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})
            }
          },
          {
            key: "VL_CUSTO",
            label: 'Vl. Custo',
            class:'text-right', 
            sortable: true,
            thStyle: { width: '7%'},
            visible: true
          },
          {
            key: "VL_VENDA",
            label: 'Vl. Venda',
            class:'text-right', 
            sortable: true,
            thStyle: { width: '7%'},
            visible: true
          },
          {
            key: "VALIDADE",
            label: 'Validade',
            class:'text-center', 
            sortable: true,
            thStyle: { width: '7%'},
            visible: true
          },
          {
            key: "DIAS_SEM_VENDA",
            label: 'Dias S/ Venda',
            class:'text-center', 
            sortable: true,
            thStyle: { width: '6%'},
            visible: true
          },
          {
            key: "actions" ,
            label: 'Ações',
            class:'text-center',
            thStyle: { width: "7%" },
            visible: true
          }
      ]
      
      if (this.opVendaPorPecas === 'N') {
        return baseFields.filter(f => !['PECAS', 'PECAS_RESERVADO', 'PECAS_DISPONIVEIS'].includes(f.key))
      }
      return baseFields
    }
  },
  watch: {
    visaoAtual() {
      this.currentPage = 1
      this._syncTools()
    }
  },
  methods: {
    ...mapMutations('estoqueDiversos', ['SET_CENTRO_ESTOQUE_ID', 'SET_PRODUTO_ID', 'SET_GRUPO_PRODUTO_ID', 'SET_EXIBIR_ZERADOS']),
    ...mapActions('estoqueDiversos', ['pesquisar']),
    
    rowKey(item) {
      if (this.visaoAtual === 'grupo') {
        return `grupo_${item.ID_GRUPO}`
      } else if (this.visaoAtual === 'vencimento') {
        return `vencimento_${item.VALIDADE || 'null'}`
      }
      return `${item.PRODUTO_ID}_${item.CENTRO_ESTOQUE_ID}`
    },
    colorirTipoTrilha(item) {
      if (item.ENTRA_SAI == 'I') return 'secondary'
      else if (item.ENTRA_SAI == 'S') return 'danger'
      else if (item.ENTRA_SAI == 'E') return 'success'
      else if (item.ENTRA_SAI == 'A') return 'info'
      else ''
    },
    selecionarLinha(item) {
      if (!item) return
      let uniqueId
      if (this.visaoAtual === 'grupo') {
        uniqueId = `grupo_${item.ID_GRUPO}`
      } else if (this.visaoAtual === 'vencimento') {
        uniqueId = `vencimento_${item.VALIDADE || 'null'}`
      } else {
        uniqueId = `${item.PRODUTO_ID}_${item.CENTRO_ESTOQUE_ID}`
      }
      this.$store.commit("estoqueDiversos/SET_REGISTRO_SELECIONADO_ID", uniqueId)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['estoqueDiversos/REGISTRO_SELECIONADO_ID']
      const uniqueId = this.rowKey(item)
      return uniqueId === selId ? 'cec-row-selected' : ''
    },
    async toggleDetalhesEstoque(row) {
      if (!row.item.PRODUTO_ID) {
        if (this.visaoAtual === 'grupo') {
          const key = row.item.ID_GRUPO || 0
          this.$set(this.gruposExpandidos, key, !this.gruposExpandidos[key])
        } else if (this.visaoAtual === 'vencimento') {
          const key = row.item.VALIDADE && row.item.VALIDADE !== 'Sem Validade' ? moment(row.item.VALIDADE).format('YYYY-MM-DD') : 'Sem Validade'
          this.$set(this.vencimentosExpandidos, key, !this.vencimentosExpandidos[key])
        }
        row.toggleDetails()
        return
      }

      if (row.detailsShowing) {
        row.toggleDetails()
        return
      }

      const uniqueId = `${row.item.PRODUTO_ID}_${row.item.CENTRO_ESTOQUE_ID}`
      this.$store.commit("estoqueDiversos/SET_REGISTRO_SELECIONADO_ID", uniqueId)

      if (!row.item.etiquetas && !row.item.loading) {
        this.$set(row.item, 'loading', true)
        this.$store.commit('controle/setAguardando', true)

        const etiquetas = await this.buscarEtiquetasEstoque(row.item.PRODUTO_ID, row.item.CENTRO_ESTOQUE_ID)

        this.$set(row.item, 'etiquetas', etiquetas)
        this.$set(row.item, 'loading', false)
        this.$store.commit('controle/setAguardando', false)
      }

      row.toggleDetails()
    },
    async buscarEtiquetasEstoque(produtoId, centroEstoqueId) {
      try {
        const response = await this.$http.get(`/api/protected/estoqueetiqueta/etiquetasEstoquePorProduto/${produtoId}/${centroEstoqueId}`)
        return response.data || []
      } catch (error) {
        console.error('Erro ao buscar etiquetas:', error)
        this.$root.$bvToast.toast('Erro ao carregar etiquetas do produto', {
          title: 'Erro',
          autoHideDelay: 3000,
          variant: 'danger',
          appendToast: true
        })
        return []
      }
    },
    formatarMoeda(value) {
      if (value == null || value === '') return 'R$ 0,00'
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    formatarPeso(value) {
      if (value == null || value === '') return '0,000'
      return value.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 3 })
    },
    formatarData(value) {
      if (!value) return '-'
      if (value === 'Sem Validade') return 'Sem Validade'
      const m = moment(value)
      return m.isValid() ? m.format('DD/MM/YYYY') : 'Sem Validade'
    },
    formatarOrigemLote(origem) {
      const map = {
        C: 'Compra',
        P: 'Produção',
        A: 'Ajuste'
      }

      return map[origem] || origem || '-'
    },
    corDiasSemVenda(dias) {
      if (!dias) return 'secondary'
      if (dias <= 30) return 'success'
      if (dias <= 60) return 'warning'
      return 'danger'
    },
    variantSituacao(situacao) {
      // Converte para string para garantir compatibilidade com números e strings
      const sit = String(situacao)
      const map = {
        '2': 'info',      // Aguardando
        '3': 'warning',   // Aberto
        '4': 'primary',   // Em Produção
        '5': 'success',   // Produzido
        '6': 'secondary'  // Finalizado
      }
      return map[sit] || 'secondary'
    },
    descricaoSituacao(situacao) {
      // Converte para string para garantir compatibilidade com números e strings
      const sit = String(situacao)
      const map = {
        '2': 'Aguardando',
        '3': 'Aberto',
        '4': 'Em Produção',
        '5': 'Produzido',
        '6': 'Finalizado'
      }
      return map[sit] || sit
    },
    variantSituacaoProcesso(situacao) {
      const sit = String(situacao || 'L')
      const map = {
        'L': 'warning',
        'C': 'danger',
        'F': 'success'
      }
      return map[sit] || 'secondary'
    },
    descricaoSituacaoProcesso(situacao) {
      const sit = String(situacao || 'L')
      const map = {
        'L': 'Lançamento',
        'C': 'Cancelado',
        'F': 'Finalizado'
      }
      return map[sit] || sit
    },
    async abrirModalReservados(item) {
      this.$store.commit('controle/setAguardando', true)
      
      try {
        const [responsePedidos, responseProcessos] = await Promise.all([
          this.$http.get(`/api/protected/estoque/getReservados/${item.CENTRO_ESTOQUE_ID}/${item.PRODUTO_ID}`),
          this.$http.get(`/api/protected/estoque/getReservadosProducaoFormula/${item.CENTRO_ESTOQUE_ID}/${item.PRODUTO_ID}`)
        ])
        
        this.dadosModalReservados.produtoId = item.PRODUTO_ID
        this.dadosModalReservados.nomeProduto = item.DESCRICAO
        this.dadosModalReservados.centroEstoque = item.DESCRICAO_CENTRO_ESTOQUE
        this.dadosModalReservados.totalReservado = item.PECAS_RESERVADO || 0
        this.dadosModalReservados.totalPesoReservado = item.QUANT_RESERVADA_PRODUCAO || 0
        this.dadosModalReservados.pedidos = responsePedidos.data || []
        this.dadosModalReservados.processos = responseProcessos.data || []
        
        this.$refs['modal-reservados'].show()
        this.$store.commit('controle/setAguardando', false)
      } catch (error) {
        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast(`Falha ao buscar pedidos reservados!`, {
          title: 'Erro',
          autoHideDelay: 3000,
          variant: 'danger',
          appendToast: true
        })
      }
    },
    async abrirModalSaldoCentros(item) {
      this.$store.commit('controle/setAguardando', true)
      
      try {
        const usuarioId = window.localStorage.getItem('usuarioId')
        const produtoId = item.PRODUTO_ID
        const response = await this.$http.get(`/api/protected/estoque/pesquisarSintetico?centroEstoqueId=&produtoId=${produtoId}&usuarioId=${usuarioId}&exibirZerados=false`)
        
        // Mapeia os dados da mesma forma que o store
        const centros = response.data.map(est => ({
          DESCRICAO_CENTRO_ESTOQUE: est.DESCRICAO_CENTRO_ESTOQUE,
          UND_ENT: est.ID_UNIDADE_COMERCIAL,
          PECAS: est.PECAS,
          QUANT: est.QUANT,
          MEDIA_ESTOQUE: est.MEDIA_ESTOQUE || 0,
          OP_PESO_FIXO: est.OP_PESO_FIXO || '0',
          PESO_LIQUIDO: est.PESO_LIQUIDO || 0,
          QUANT_RESERVADA_PRODUCAO: est.QUANT_RESERVADA_PRODUCAO || 0,
          PECAS_RESERVADO: est.PECAS_RESERVADO || 0,
          PECAS_DISPONIVEIS: est.PECAS_DISPONIVEIS || 0,
          VL_CUSTO: est.PRECOCUSTO,
          VL_VENDA: est.VL_VENDA
        }))

        // Calcula todos os totais
        const totalPecas = centros.reduce((acc, centro) => acc + (centro.PECAS || 0), 0)
        const totalPeso = centros.reduce((acc, centro) => acc + (centro.QUANT || 0), 0)
        const totalPesoReservado = centros.reduce((acc, centro) => acc + (centro.QUANT_RESERVADA_PRODUCAO || 0), 0)
        const totalPesoDisponivel = totalPeso - totalPesoReservado
        const totalReservado = centros.reduce((acc, centro) => acc + (centro.PECAS_RESERVADO || 0), 0)
        const totalDisponivel = centros.reduce((acc, centro) => acc + (centro.PECAS_DISPONIVEIS || 0), 0)
        const totalCusto = centros.reduce((acc, centro) => acc + (Number(centro.VL_CUSTO || 0) * Number(centro.QUANT || 0)), 0)
        const totalVenda = centros.reduce((acc, centro) => acc + (Number(centro.VL_VENDA || 0) * Number(centro.QUANT || 0)), 0)
        
        this.dadosModalSaldoCentros.produtoId = item.PRODUTO_ID
        this.dadosModalSaldoCentros.nomeProduto = item.DESCRICAO
        this.dadosModalSaldoCentros.totalPecas = totalPecas
        this.dadosModalSaldoCentros.totalPeso = totalPeso
        this.dadosModalSaldoCentros.totalPesoReservado = totalPesoReservado
        this.dadosModalSaldoCentros.totalPesoDisponivel = totalPesoDisponivel
        this.dadosModalSaldoCentros.totalReservado = totalReservado
        this.dadosModalSaldoCentros.totalDisponivel = totalDisponivel
        this.dadosModalSaldoCentros.totalCusto = totalCusto
        this.dadosModalSaldoCentros.totalVenda = totalVenda
        this.dadosModalSaldoCentros.centros = centros
        const colunasSaldoCentros = this.$options.data.call(this).dadosModalSaldoCentros.colunas
        this.dadosModalSaldoCentros.colunas = this.opVendaPorPecas === 'N'
          ? colunasSaldoCentros.filter(coluna => !['PECAS', 'PECAS_DISPONIVEIS'].includes(coluna.key))
          : colunasSaldoCentros
        
        this.$refs['modal-saldo-centros'].show()
        this.$store.commit('controle/setAguardando', false)
      } catch (error) {
        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast(`Falha ao buscar saldo dos centros de estoque!`, {
          title: 'Erro',
          autoHideDelay: 3000,
          variant: 'danger',
          appendToast: true
        })
      }
    },
    async abrirModalLotes(item) {
      this.$store.commit('controle/setAguardando', true)

      try {
        const response = await this.$http.get(`/api/protected/estoque/getLotesByProdutoCentro/${item.PRODUTO_ID}/${item.CENTRO_ESTOQUE_ID}`)

        this.dadosModalLotes.produtoId = item.PRODUTO_ID
        this.dadosModalLotes.nomeProduto = item.DESCRICAO
        this.dadosModalLotes.nomeCentroEstoque = item.DESCRICAO_CENTRO_ESTOQUE
        this.dadosModalLotes.items = response.data || []

        this.$refs['modal-lotes'].show()
        this.$store.commit('controle/setAguardando', false)
      } catch (error) {
        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast('Falha ao buscar lotes do produto!', {
          title: 'Erro',
          autoHideDelay: 3000,
          variant: 'danger',
          appendToast: true
        })
      }
    },
    async filtrar () {
      // Lógica de visibilidade da coluna
      const colIdx = this.fields.findIndex(f => f.key === "DESCRICAO_CENTRO_ESTOQUE");
      if (colIdx >= 0) {
        if (this.centroEstoqueIdLocal && this.centroEstoqueIdLocal > 0) {
             // Precisamos garantir que a reatividade funcione se alterarmos o array
             // Mas o b-table usa 'fields' diretamente. 
             // Se quisermos esconder, melhor usar 'thClass: d-none' ou filtrar o array, 
             // mas o mixin pode esperar os fields estáticos. 
             // Vamos manter simples: se filtrou por centro, a coluna aparece mas com valores iguais.
             // O código original modificava 'pesquisa.colunas[2].visible'.
             // Se quisermos manter isso, teríamos que tornar 'fields' computado ou watcher.
             // Para simplificar na modernização, vou deixar a coluna visível sempre ou usar CSS.
             // Mas como estamos "Modernizando", o usuário consegue filtrar a coluna usando o SetFilter também.
        }
      }

      this.isBusy = true
      await this.pesquisar()
      this.isBusy = false
    },
    limpar() {
        this.centroEstoqueIdLocal = null
        this.produtoIdLocal = null
        this.grupoProdutoIdLocal = null
        if(this.$refs.produtopesquisa) this.$refs.produtopesquisa.limpar()
        if(this.$refs.grupoProdutoPesquisa) this.$refs.grupoProdutoPesquisa.limpar()
        this.onClear() // Do mixin
        // Limpar a lista no store se necessário, ou filtrar novamente vazio
    },
    onRecalcular () {
      this.$store.commit('controle/setAguardando', true)
      let uri = `/api/protected/estoque/recalcular`
      this.$http.post(uri)
        .then(() => {
          this.$root.$bvToast.toast(`Estoque Recalculado com Sucesso. \n Utilize o botão Pesquisar Novamente!!! !! `, {
            title: 'Falha',
            autoHideDelay: 5000,
            variant: 'success',
            appendToast: true
          })
          this.$store.commit('controle/setAguardando', false)
        }).catch((error) => {
          this.$root.$bvToast.toast(`Operação Indisponível no momento!! ${error}`, {
            title: 'Falha',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true
          })
        })
    },
    async abrirModalTrilha(item) {
      
      // item aqui é o objeto row do b-table (item.item contém o dado)
      const dado = item.item ? item.item : item; // Precaução, as vezes passamos o dado direto
      
      this.$store.commit('controle/setAguardando', true)
      
      try {
        const result = await this.$http.get(`/api/protected/estoque/listarTrilhaPeloInventario/${dado.CENTRO_ESTOQUE_ID}/${dado.PRODUTO_ID}`)
        
        this.dadosModalTrilha.produtoId = dado.PRODUTO_ID
        this.dadosModalTrilha.nomeProduto = dado.DESCRICAO
        this.dadosModalTrilha.centroEstoqueId = dado.CENTRO_ESTOQUE_ID
        this.dadosModalTrilha.nomeCentroEstoque = dado.DESCRICAO_CENTRO_ESTOQUE
        this.dadosModalTrilha.saldoAtual = dado.QUANT  ? dado.QUANT.toLocaleString('pt-BR', {style: 'decimal',  minimumFractionDigits: 3})   : '0,000'
        this.dadosModalTrilha.dataInventario = ''
        
        this.dadosModalTrilha.tabela.items = result.data
        const primeiroMovimento = result.data && result.data.length ? result.data[0] : null
        const opVendaPorPecasTrilha = primeiroMovimento && primeiroMovimento.OP_VENDA_POR_PECAS
          ? primeiroMovimento.OP_VENDA_POR_PECAS
          : this.opVendaPorPecas
        const colunasTrilha = this.$options.data.call(this).dadosModalTrilha.tabela.colunas
        this.dadosModalTrilha.tabela.colunas = opVendaPorPecasTrilha === 'N'
          ? colunasTrilha.filter(coluna => !['PECAS', 'SALDO_PECAS'].includes(coluna.key))
          : colunasTrilha
        
        this.dadosModalTrilha.dataInventario = primeiroMovimento && primeiroMovimento.DT_INV_BASE
          ? moment(String(primeiroMovimento.DT_INV_BASE)).format('DD/MM/YYYY')
          : ''
        this.$refs['modal-trilha'].show()
        this.$store.commit('controle/setAguardando', false)
      } catch (error) {
        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast(`Falha ao executar a Operação!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })
      }
    },
     imprimir() {
      
      let centroEstoqueId = this.centroEstoqueIdLocal !== null ? `&centroEstoqueId=${this.centroEstoqueIdLocal}` : ''
      let produtoId = this.produtoIdLocal !== null ? `&produtoId=${this.produtoIdLocal}` : ''
      let grupoProdutoId = this.grupoProdutoIdLocal !== null ? `&grupoProdutoId=${this.grupoProdutoIdLocal}` : ''

      let uri = `/api/protected/relatorios/estoque/relestoquesinteticotodoscentros?lbusuario=${window.localStorage.getItem('login') + centroEstoqueId + produtoId + grupoProdutoId}`
      this.$store.commit('controle/setAguardando', true)
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.$store.commit('controle/setAguardando', false)
          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'relEstoque.pdf')
          link.download = 'relEstoque.pdf'
          const janela = window.open(link)
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = 'Estoque'
            }, 1000);
          }
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          let msg = erro.response && erro.response.data ? erro.response.statusText : ''
          this.$root.$bvToast.toast(`Falha ao gerar o relatório!!! ` + msg, {
            title: 'Falha',
            autoHideDelay: 2000,
            variant: 'danger',
            appendToast: true
          })
        })
    },
  },
  created () {
    let uri = this.$http.defaults.baseURL.concat('api/protected/centroestoque/listartodos')
    this.$http.get(uri)
    .then((data) => {
      this.centroEstoqueOptions = []
      let i
      for (i = 0; i < data.data.length; i++) {
        this.centroEstoqueOptions.push({value: data.data[i].ID, text: data.data[i].CODIGONOME})
      }
    }).catch((error) => {
      this.$root.$bvToast.toast(`Os CENTROS DE ESTOQUE estão Indisponíveis!!! !! ` + error, {
        title: 'Falha',
        autoHideDelay: 5000,
        variant: 'warning',
        appendToast: true
      })
    })

    // Busca parametrização de venda por peças
    this.$http.get('/api/protected/parametro/getDados')
      .then(response => {
        if (response.data && response.data.length > 0) {
          this.opVendaPorPecas = response.data[0].OP_VENDA_POR_PECAS || 'S'
          this.opEstoqueEtiquetado = response.data[0].OP_ESTOQUE_ETIQUETADO || '0'
        }
      })
      .catch(error => {
        console.error('Erro ao buscar parâmetros do sistema:', error)
      })
  }
}
</script>

<style scoped>
  /* Modern Premium Modal Styles */
  .modal-header-premium {
    border-bottom: none;
  }

  .modal-header-gradient-purple {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  }

  .header-icon-wrapper {
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    font-size: 1.5rem;
  }

  .bg-white-10 {
    background-color: rgba(255, 255, 255, 0.15) !important;
  }

  .opacity-75 {
    opacity: 0.75;
  }

  .modal-info-bar {
    background: #f8fafc;
  }

  .modal-section-title {
    font-size: 0.9rem;
    font-weight: 700;
    color: #2d3748;
    border-bottom: 2px solid #edf2f7;
    padding-bottom: 0.5rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .modal-label-premium {
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #6c757d;
    margin-bottom: 0.4rem;
    display: block;
  }

  .shadow-xs {
    box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
  }

  .btn-soft-danger {
    background-color: rgba(248, 108, 107, 0.1);
    color: #f86c6b;
    border: none;
  }
  
  .btn-soft-danger:hover {
    background-color: #f86c6b;
    color: white;
  }

  .modal-footer-premium {
    border-top: 1px solid #e2e8f0;
  }

  .modal-content-scroll {
    max-height: 60vh;
    overflow-y: auto;
  }

  /* ==================== TABLE CARD ROWS STYLES ==================== */
  
  .table-card-container {
    background: transparent;
  }

  .table-card-rows >>> .table.b-table {
    width: 100%;
    table-layout: fixed;
    border-collapse: separate;
  }

  .table-card-rows >>> .b-table-sticky-header,
  .table-card-rows >>> .b-table-sticky-header .table-responsive {
    overflow-x: hidden;
  }

  .table-card-rows >>> .b-table-sticky-header > .table.b-table > thead > tr > th,
  .table-card-rows >>> .b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-clip: padding-box;
  }

  .table-card-rows >>> tbody tr {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 0.75rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    border: 1px solid #e2e8f0;
    transition: all 0.2s ease;
  }

  .table-card-rows >>> tbody tr:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  .table-card-rows >>> tbody tr.cec-row-selected {
    border: 2px solid #667eea;
    box-shadow: 0 4px 16px rgba(102, 126, 234, 0.2);
  }

  .table-card-rows >>> tbody tr td {
    border: none;
    vertical-align: middle;
    padding: 0.85rem 0.75rem;
  }

  .table-card-rows >>> tbody tr td:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  .table-card-rows >>> tbody tr td:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  /* Dark mode support */
  .table-card-rows.table-dark >>> tbody tr {
    background: #2d3748;
    border-color: #4a5568;
  }

  /* Botões de ação */
  .btn-action-icon {
    width: 32px;
    height: 32px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    transition: all 0.2s ease;
    margin: 0 2px;
  }

  .btn-soft-success {
    background-color: rgba(76, 175, 80, 0.15);
    color: #4caf50;
    border: none;
  }

  .btn-soft-success:hover {
    background-color: #4caf50;
    color: white;
    transform: scale(1.05);
  }

  .btn-soft-info {
    background-color: rgba(99, 179, 237, 0.15);
    color: #63b3ed;
    border: none;
  }

  .btn-soft-info:hover {
    background-color: #63b3ed;
    color: white;
    transform: scale(1.05);
  }

  /* Modal gradient success */
  .modal-header-gradient-success {
    background: linear-gradient(135deg, #4caf50 0%, #45a047 100%) !important;
  }

  /* Modal gradient warning */
  .modal-header-gradient-warning {
    background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%) !important;
  }

  .btn-soft-warning {
    background-color: rgba(255, 193, 7, 0.15);
    color: #ffc107;
    border: none;
  }

  .btn-soft-warning:hover {
    background-color: #ffc107;
    color: white;
    transform: scale(1.05);
  }

  .modal-header-gradient-secondary {
    background: linear-gradient(135deg, #6c757d 0%, #495057 100%) !important;
  }

  .btn-soft-secondary {
    background-color: rgba(108, 117, 125, 0.15);
    color: #6c757d;
    border: none;
  }

  .btn-soft-secondary:hover {
    background-color: #6c757d;
    color: white;
    transform: scale(1.05);
  }

  /* Gap utility */
  .gap-1 {
    gap: 0.25rem;
  }

  /* Responsive */
  @media (max-width: 768px) {
    .table-card-container {
      padding-left: 0.5rem !important;
      padding-right: 0.5rem !important;
    }

    .table-card-rows >>> tbody tr {
      margin-bottom: 0.5rem;
    }
  }

  /* Estilos das Sub-tabelas Aninhadas */
  .nested-products-table {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    margin-bottom: 1rem;
  }
  
  .nested-products-table >>> tbody tr {
    background: #fdfdfd !important;
    box-shadow: none !important;
    border: 1px solid #edf2f7 !important;
    margin-bottom: 0 !important;
    transform: none !important;
  }
  
  .nested-products-table >>> tbody tr:hover {
    background: #f7fafc !important;
    box-shadow: none !important;
    transform: none !important;
  }
  
  .nested-products-table.table-dark >>> tbody tr {
    background: #1a202c !important;
    border-color: #2d3748 !important;
  }

  .nested-products-table.table-dark >>> tbody tr:hover {
    background: #2d3748 !important;
  }

  .nested-products-table >>> tbody tr td {
    padding: 0.5rem 0.75rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/estoque/EstoqueDiversos.vue